export default __webpack_public_path__ + "static/media/27.8084ce5c.jpg";